// extracted by mini-css-extract-plugin
export default {"container__hidden":"H3IMGd5","group":"eLMg6Nh","header":"qljN_kD TNLlZ7K london3","container":"fAAF5ET","body":"x1ETIN7"};